// src/pages/PasswordResetPage.js
import React from "react";
import PasswordReset from "../containers/Auth/PasswordReset";

export default function PasswordResetPage() {
  return <PasswordReset />;
}
